// frontend/src/components/layouts/PublicLayout.tsx

import { useId } from 'react';
import { Outlet } from 'react-router-dom';
import { Footer } from '@/components/shared/Footer';
import { ModeToggle } from '@/components/shared/mode-toggle';

export default function PublicLayout() {
  const containerId = useId();

  return (
    <div className="relative flex h-screen flex-col overflow-y-auto px-4 sm:px-0">
      <header className="absolute top-4 right-4 z-10 flex items-center gap-4">
        <div id={`verified-email-container-${containerId}`}></div>
        <ModeToggle />
      </header>
      {/* The main area will now grow to fill available space */}
      <main className="flex flex-1 flex-col items-center justify-start pt-8 pb-8">
        <Outlet />
      </main>
      {/* The footer will now appear at the bottom */}
      <Footer />
    </div>
  );
}
